import React, { Component } from "react";
import cloneDeep from "lodash/cloneDeep";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";
import DateRangePicker from "@cloudscape-design/components/date-range-picker";
import Multiselect from "@cloudscape-design/components/multiselect";
import Table from "@cloudscape-design/components/table";
import FormField from "@cloudscape-design/components/form-field";
import Container from "@cloudscape-design/components/container";
import ColumnLayout from "@cloudscape-design/components/column-layout";
import Textarea from "@cloudscape-design/components/textarea";
import Tabs from "@cloudscape-design/components/tabs";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
	promotionAddModalStore,
	promotionConfigModalStore,
	tournamentsAddModalStore,
} from "../stores/promotionConfigModal";
import { tournamentsStore } from "../stores/tournaments";
import { gameStore } from "../stores/games";
import { Alert } from "react-bootstrap";
import Poster from "../assets/poster.png";
import ProgressiveImage from "react-progressive-graceful-image";
import Spinner from "@cloudscape-design/components/spinner";

class PromotionConfigModal extends Component {
	constructor(props) {
		super(props);
	}


	editPromotionConfig = async() => {
		try {
			const { promotionConfigModal, setPromotionConfigModal, Interface } = this.props;


			const body = {
				fiat: promotionConfigModal.fiat,
				crypto: promotionConfigModal.crypto,
			};

			try {
				const result = await Interface.request("set", {
					class: "data",
					module: "promotion",
					method: "editConfig"
				}, body);

				Interface.addNoty("Success", "Promotion was successfully edit config");
				setPromotionConfigModal({ ...promotionConfigModal, show: false });
			} catch (error) {
				Interface.addNoty("Error", error.text || error.toString());
			}
		} catch (error) {
			console.log("ERROR PROMO", error);
		}
	}



	updateParam = (key, value) => {
		const { promotionConfigModal, setPromotionConfigModal } = this.props;
		const updatedState = cloneDeep(promotionConfigModal);
		updatedState[key] = value;
		setPromotionConfigModal(updatedState);
	};



	render() {
		const { promotionConfigModal, setPromotionConfigModal } = this.props;

		return (
			<Modal
				visible={promotionConfigModal.show}
				size="medium"
				onDismiss={() => setPromotionConfigModal({ ...promotionConfigModal, show: false })}
				header={`Edit config promotion`}
				children={
					this.props.promotionConfigModal.loaded ? (
					<SpaceBetween direction="vertical" size="l">
						<Container>
							<SpaceBetween direction="vertical" size="m">
								<FormField
									label="Deposit fiat precent"
									description="Deposit fiat precent"
									stretch
								>
									<Input
										type="number"
										value={promotionConfigModal.fiat}
										onChange={({ detail }) =>
											this.updateParam(
												"fiat",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>

								<FormField
									label="Deposit crypto precent"
									description="Deposit crypto precent"
									stretch
								>
									<Input
										type="number"
										value={promotionConfigModal.crypto}
										onChange={({ detail }) =>
											this.updateParam(
												"crypto",
												detail.value === ""
													? ""
													: detail.value
											)
										}
										placeholder="1"
										inputMode="numeric"
									/>
								</FormField>
							</SpaceBetween>
						</Container>

					</SpaceBetween>
					) : (<Box variant="div" textAlign="center">
						<Spinner size="large" />
					</Box>)
				}
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="m">
							<Button
								variant="normal"
								onClick={() =>
									setPromotionConfigModal({ ...promotionConfigModal, show: false })
								}
							>
								Close
							</Button>
							<Button
								variant="primary"
								onClick={this.editPromotionConfig}
							>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			/>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const promotionConfigModal = useRecoilValue(promotionConfigModalStore);
		const setPromotionConfigModal = useSetRecoilState(promotionConfigModalStore);


		return (
			<Component
				{...props}
				setPromotionConfigModal={setPromotionConfigModal}
				promotionConfigModal={promotionConfigModal}
			/>
		);
	};
}

export default withRecoil(PromotionConfigModal);
